// @ts-ignore
// @ts-nocheck

/* assets/pw-url-attributes.js
  Purpose:
  - Save marketing params from URL into cookies (30 days)
  - Provide global accessors to read those cookies anywhere

  Saves these params (canonical keys):
  fbclid, gclid, igshid,
  utm_campaign, utm_content, utm_id,
  utm_medium, utm_source, utm_term

  URL alias support:
  medium -> utm_medium
  source -> utm_source
  term   -> utm_term

  Cookie names:
  pw_<key>  (e.g. pw_utm_source)
  pw_params (JSON of all keys)

  Function flow (runs immediately on script load, IIFE):
  --------------------------------------------------------
    parseIncomingParams()
      |-- reads window.location.search
      |-- CANON_KEYS: read utm_ keys, fbclid, gclid, igshid directly
      '-- ALIASES: read medium/source/term, map to canonical
                   (skipped if canonical key already present)
      -> incoming {} of only the params found in the URL

    if incoming has any keys:
      saveParamsToCookies(incoming)
        |-- setCookie(pw_<key>, value, 30d) for each incoming param
        '-- rebuilds combined payload (incoming value, else existing
            getCookie(pw_<key>)) -> setCookie(pw_params, JSON, 30d)

  Global API (window.pwURLAttributes), callable anytime after load:
    get(key)   -> getCookie(pw_<key>)
    getAll()   -> { key: getCookie(pw_<key>) } for every CANON_KEYS entry present
    getJson()  -> JSON.parse(getCookie(pw_params)) or {}

  Consumed by other tracking scripts (e.g. pwtracker-required-attrs.js's
  getUTMValuesFromExistingSource()) via window.pwURLAttributes.getAll()/getJson().
*/

(function () {
  var COOKIE_DAYS = 30;
  var COOKIE_PREFIX = "pw_";

  var CANON_KEYS = ["fbclid", "gclid", "igshid", "utm_campaign", "utm_content", "utm_id", "utm_medium", "utm_source", "utm_term"];

  var ALIASES = {
    medium: "utm_medium",
    source: "utm_source",
    term: "utm_term",
  };

  function setCookie(name, value, days) {
    if (value === null || value === undefined || value === "") return;

    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);

    var secure = location.protocol === "https:" ? "; Secure" : "";
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(String(value)) + "; Expires=" + d.toUTCString() + "; Path=/" + "; SameSite=Lax" + secure;
  }

  function getCookie(name) {
    var key = encodeURIComponent(name) + "=";
    var parts = document.cookie.split("; ");
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(key) === 0) {
        return decodeURIComponent(parts[i].substring(key.length));
      }
    }
    return null;
  }

  function parseIncomingParams() {
    var out = {};
    var qs = window.location.search;
    if (!qs || qs.length < 2) return out;

    var sp = new URLSearchParams(qs);

    // 1) Read canonical params directly (utm_* etc.)
    CANON_KEYS.forEach(function (k) {
      var v = sp.get(k);
      if (v) out[k] = v;
    });

    // 2) Read aliases & map to canonical (canonical wins)
    Object.keys(ALIASES).forEach(function (aliasKey) {
      var canonKey = ALIASES[aliasKey];
      if (out[canonKey]) return;

      var v = sp.get(aliasKey);
      if (v) out[canonKey] = v;
    });

    return out;
  }

  function saveParamsToCookies(params) {
    // Save each param in its own cookie
    CANON_KEYS.forEach(function (k) {
      if (params[k]) setCookie(COOKIE_PREFIX + k, params[k], COOKIE_DAYS);
    });

    // Save combined JSON cookie for convenience
    var payload = {};
    CANON_KEYS.forEach(function (k) {
      var v = params[k] || getCookie(COOKIE_PREFIX + k);
      if (v) payload[k] = v;
    });
    setCookie(COOKIE_PREFIX + "params", JSON.stringify(payload), COOKIE_DAYS);
  }

  /* ===== Global API (use anywhere) ===== */
  window.pwURLAttributes = {
    keys: CANON_KEYS.slice(),

    // Read single value by canonical key (e.g. "utm_source")
    get: function (key) {
      return getCookie(COOKIE_PREFIX + key);
    },

    // Read all canonical keys as object
    getAll: function () {
      var all = {};
      CANON_KEYS.forEach(function (k) {
        var v = getCookie(COOKIE_PREFIX + k);
        if (v) all[k] = v;
      });
      return all;
    },

    // Read combined JSON cookie as object
    getJson: function () {
      var v = getCookie(COOKIE_PREFIX + "params");
      try {
        return v ? JSON.parse(v) : {};
      } catch (e) {
        return {};
      }
    },
  };

  // On load: save only if URL contains relevant params
  var incoming = parseIncomingParams();
  if (Object.keys(incoming).length) {
    saveParamsToCookies(incoming);
  }
  console.log("pw-url-attributes loaded");
})();
